import React, { useCallback } from "react";
import { Col, Row } from "react-bootstrap";

import { TextWithLoader } from "components";
import { getFormattedDate, getFullName } from "helpers";
import { TerminalStatusTypes } from "types/enums";

import styles from "../terminalSolution.module.scss";

type TerminalInfoProps = {
	terminal: { [key: string]: any };
	isLoading?: boolean;
};

const TerminalInfo = ({ terminal, isLoading = false }: TerminalInfoProps) => {
	const { status, updatedBy, updatedAt } = terminal;

	const DateInfo = useCallback(
		({ value, ...props }) => (
			<TextWithLoader
				{...props}
				value={getFormattedDate({ date: value })}
				loading={isLoading}
				labelCol={5}
			/>
		),
		[isLoading],
	);

	const terminalStatus =
		TerminalStatusTypes.getByName(status)?.displayName || "Pending";

	return (
		<div
			className={styles.terminalInfoSection}
			data-autotest="terminalInfoSection"
		>
			<Row className="form-group">
				<Col md={6}>
					<TextWithLoader
						label="Terminal Status"
						value={terminalStatus}
						loading={isLoading}
					/>
				</Col>
			</Row>
			{status === TerminalStatusTypes.Complete.name && (
				<Row className="form-group">
					<Col md={6}>
						<DateInfo
							label="Complete / Updated On"
							value={updatedAt}
						/>
					</Col>
					<Col md={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Complete / Updated By"
							value={getFullName(updatedBy)}
							loading={isLoading}
							labelCol={6}
							valueCol={6}
						/>
					</Col>
				</Row>
			)}

			<hr className={styles.divider} />
		</div>
	);
};

export default TerminalInfo;
